import { palette } from './palette';
import contactUsBg from 'assets/images/contactUs-bg.webp';
import employerBg from 'assets/images/employee-banner-img.webp';

export const homeStyle = {
  '& .customDialogue': {
    '& .customFormSubmitButton': {
      backgroundColor: palette.verticalBar.used,
      color: palette.text.highlight,
      borderRadius: 0,
      '&:hover': {
        background: palette.verticalBar.used,
      },
    },
  },
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      background: palette.text.primary,
      color: palette.text.highlight,
    },
    '& .theme-highlight-color': {
      fontWeight: 'bold',
      color: palette.text.secondary,
    },
    '& .disclosure_statement': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.background.secondaryLight,
        '&:hover': {
          background: palette.verticalBar.used,
        },
      },
    },
  },
  '& .reinstate_subscription, & .view_disclosure_statement': {
    '& .MuiButton-containedPrimary': {
      color: palette.text.highlight,
    },
  },
  '& .custom-drawer-wrapper': {
    '& .drawer-title-container': {
      background: palette.primary.main,
    },
    '& .customPromoToggle': {
      color: palette.text.secondary,
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: palette.background.secondaryLight,
      '&:hover': {
        background: palette.verticalBar.used,
      },
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: palette.background.secondaryLight,
      '&:hover': {
        background: palette.verticalBar.used,
      },
    },
  },

  '& .header-wrapper': {
    borderStyle: 'solid',
    borderWidth: '0px 0px 8px 0',

    '& .top-bar-logo-container': {
      '& a img': {
        height: '48px',
        width: 'auto',
      },
    },
  },

  '.dentistryinmotion-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
      '& .app-main-box': {
        background: palette.text.highlight,
        display: 'flex',
        flexDirection: 'column',
        '& .howitworks-section': {
          order: 1,
        },
        '& .home-static-hero-wrapper': {
          order: 2,
        },
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .faq-hero-section':
      {
        marginTop: '48px',
        background: palette.background.primary,
        '& .hero-header-title, .hero-header-subtitle': {
          color: palette.text.highlight,
        },
        '& .section-header': {
          '@media(max-width: 900px)': {
            marginBottom: 0,
          },
        },
        '& .hero-link-button': {
          background: palette.text.highlight,
          color: palette.background.primary,
          '&:hover': {
            background: palette.background.primary,
            color: palette.text.highlight,
          },
        },
        '& .hero-home-button': {
          background: palette.background.primary,
          color: palette.text.highlight,
          borderColor: `${palette.text.highlight} !important`,
          '&:hover': {
            background: palette.text.highlight,
            color: palette.background.primary,
            borderColor: `${palette.text.highlight} !important`,
          },
        },
      },

    '& .link': {
      color: palette.text.primary,
      fontSize: '20px',
    },

    '& .savings-hero-section, .faq-hero-section': {
      '& .hero-link-button': {
          background: `${palette.primary.contrastText} !important`,
          color: `${palette.text.description} !important`,
        },
        '& .hero-home-button': {
          background: `transparent !important`,
          color: `${palette.text.highlight} !important`,
          borderColor: `${palette.primary.main} !important`,
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      paddingTop: '60px',
      width: '100%',
      position: 'relative',
      '@media(min-width: 900px)': {
        background: palette.background.paper,
      },
      '& .primary-button': {
        backgroundColor: palette.background.secondaryLight,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.background.secondaryLight,
        },
      },
      '& .secondary-button': {
        backgroundColor: palette.background.paper,
        color: palette.text.tertiary,
        border: `1px solid ${palette.text.tertiary}`,
        '&:hover': {
          backgroundColor: palette.text.tertiary,
          color: palette.text.highlight,
        },
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 600,
          lineHeight: '76px',
          fontSize: 72,
          color: palette.text.primary,
          '@media(max-width: 1024px)': {
            maxWidth: 700,
            fontSize: 48,
          },
        },
        '& .hero-subtitle': {
          maxWidth: 600,
          fontSize: 20,
          fontWeight: '400 !important',
          color: palette.text.primary,
        },
      },
      '@media(max-width: 900px)': {
        '& .section-alternate__content': {
          background: palette.background.paper,
        },
      },
      '& .section-header__cta-wrapper': {
        '@media(max-width: 900px)': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
      },
      '& .section-header__cta-container': {
        '@media(max-width: 900px)': {
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
      '& .home-hero-title': {
        maxWidth: '580px',
      },
      '& .home-hero-subtitle': {
        maxWidth: '580px',
      },
      '& .image-wrapper': {
        '@media(max-width: 900px)': {     
          padding: '24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          width: '100%',
          maxWidth: '560px',
          borderRadius: 10,
          height: 'auto',
          '@media(max-width: 900px)': {
            maxWidth: '100%',
          },
        },
      },

      /* HeroVariant3 — 50/50 split, all screen sizes */
      '&.home-hero-variant-3': {
        paddingTop: 0,
        background: 'none',
        minHeight: 560,
        '@media(min-width: 1600px)': {
          minHeight: 800,
        },

        '& .hero-content-side': {
          paddingTop: '40px',
          marginTop: '80px',
          background: palette.background.paper,

          '& .section-header': {
            maxWidth: '560px !important',
          },

          '& .hero-title': {
            fontSize: 52,
            lineHeight: '62px',
            color: palette.text.primary,
            maxWidth: '100%',
            '@media(max-width: 1200px)': {
              fontSize: 40,
              lineHeight: '50px',
            },
            '@media(max-width: 768px)': {
              fontSize: 28,
              lineHeight: '36px',
            },
          },
          '& .hero-subtitle': {
            fontSize: 18,
            fontWeight: '400 !important',
            color: palette.text.primary,
            maxWidth: '100%',
            marginTop: 12,
            '@media(max-width: 768px)': {
              fontSize: 14,
            },
          },
          '& .hero-link-button': {
            backgroundColor: palette.background.secondaryLight,
            color: palette.text.highlight,
            '&:hover': {
              backgroundColor: palette.text.highlight,
              color: palette.background.secondaryLight,
            },
          },
          '& .login-button': {
            backgroundColor: palette.background.paper,
            color: palette.text.tertiary,
            border: `1px solid ${palette.text.tertiary}`,
            '&:hover': {
              backgroundColor: palette.text.tertiary,
              color: palette.text.highlight,
            },
          },
        },

        '& .hero-image-side': {
          '& .hero-split-image': {
            objectPosition: 'center top',
          },
        },
      },
    },

    '& .section-alternate__content': {
      padding: '72px 16px',
      '@media(max-width: 900px)': {
        padding: '42px 16px',
      },
    },

    '& .footer-wrapper': {
      background: palette.background.description,
      color: palette.primary.contrastText,
      '& .footer-link, .copyrights-footer-link': {
        color: palette.primary.contrastText,
      },
      '& .copyrights-footer': {
        borderTop: `1px solid ${palette.divider}`,
      },
    },

    /* Benefits - Styles */
    '& .definition-section-variant-8': {
      '& .cover-image-col': {
        maxHeight: '710px !important',
        maxWidth: '635px !important',
      },
      '& .definition-inner-grid': {
        justifyContent: 'space-around',
      },
      '& .service-tile-wrapper': {
        maxWidth: '550px !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.secondary,
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '180px',
        height: '180px',
        backgroundImage: 'url(/images/subscription-left-top-pattern.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top left',
        pointerEvents: 'none',
        zIndex: 1,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        width: '180px',
        height: '180px',
        backgroundImage: 'url(/images/subscription-right-top-pattern.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top right',
        pointerEvents: 'none',
        zIndex: 1,
      },
      '& .subscription-bg': {
        background: palette.background.secondary,
      },
      '& .section-header__subtitle': {
        fontSize: '20px',
        lineHeight: '28px',
      },
      '@media screen and (max-width: 768px)': {
        '& .summary-text': {
          fontSize: '16px',
          marginTop: '0px',
        },
      },
     '& #pricing-benefit-section': {
        position: 'relative',
        '& .section-header__title, .section-header__subtitle, .subscription-tabs-label, .summary-text, .summary-subtext':
          {
            color: palette.text.highlight,
          },
        '& .section-header__title': {
          fontSize: '44px',
        },
        '& .planCard': {
          border: `1px solid transparent`,
          '&:hover': {
            background: palette.text.highlight,
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
          },
          '& .MuiButton-root': {
            backgroundColor: `transparent !important`,
            color: palette.text.description,
            border: `2px solid ${palette.background.secondaryLight}`,
            '&:hover': {
              background: `${palette.background.secondaryLight} !important`,
              color: `${palette.text.highlight} !important`,
              border: `2px solid ${palette.background.secondaryLight}`,
            },
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 'bold',
            },
          },
          '& .customGetStarted': {
            backgroundColor: palette.background.secondaryLight,
            '&:hover': {
              background: palette.verticalBar.used,
            },
          },
        },
        '& .select-plan-button': {
          '&:hover': {
            background: `${palette.primary.main} !important`,
          },
        },

        '& .subscription-section': {
          padding: '50px 80px 50px',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '@media(max-width: 900px)': {
          '& .subscription-section': {
            padding: '50px 30px 50px',
            '& .section-header': {
              marginBottom: '0px',
            },
          },
        },
        '& .savings-summary-link': {
          color: palette.primary.contrastText,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.background.dark,
      },
      '& .MuiSwitch-track': {
        borderColor: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked': {
        color: palette.text.highlight,
        borderColor: palette.background.primary,
        '& .MuiSwitch-thumb': {
          borderColor: palette.primary.main,
          backgroundColor: palette.background.dark,
        },
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        borderColor: palette.primary.main,
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '& .react-multi-carousel-dot--active button': {
        backgroundColor: palette.text.highlight,
      },
    },

    '& .savings-contact-card': {
      background: palette.background.light,
      '& .contact-title': {
        paddingBottom: '10px',
        fontSize: '38px',
      },
      '& .contact-subtitle': {
        paddingBottom: '10px',
        fontSize: '19px',
      },
      '& .primary-contact-button, .secondary-contact-button': {
        height: '62px',
        width: '210px !important',
        fontSize: '16px',
        border: `2px solid ${palette.text.highlight} !important`,
        '& .MuiButton-endIcon': {
          display: 'none',
        },
      },
      '& .primary-contact-button': {
        marginRight: '50px',
      },
      '@media(max-width: 900px)': {
        '& .primary-contact-button': {
          marginRight: '0px',
          marginBottom: '40px',
        },
        '& .section-header__cta-container': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },

    /*Description Styling */
    '& .descriptionRootContainer': {
      borderBottom: `13px solid ${palette.text.primary}`,
      '& .customDesktopGridImg': {
        marginTop: -70,
      },
      '@media(max-width: 900px)': {
        background: 'none',
        '& .how-cover-image': {
          borderBottom: `13px solid ${palette.text.primary}`,
        },
        '& .customDesktopGridImg': {
          marginTop: -40,
        },
      },
    },
    '& .customContentHeader': {
      fontSize: '38px',
      maxWidth: '600px',
    },
    '& .customInnerContentHeader': {
      fontWeight: 'bolder',
      fontSize: '20px',
      color: palette.text.description,
    },
    '& .customDescription': {
      fontWeight: 300,
    },

    '& .descriptionButton': {
      fontSize: '18px',
      height: '62px',
      width: '240px',
      border: `2px solid ${palette.text.highlight}`,
    },

    '& .customContentGrid': {
      marginTop: '42px',
    },

    '@media(max-width: 900px)': {
      '& .customOverlapImageContainer': {
        bottom: '36px',
      },
      '& .customContentGrid': {
        padding: '0px 30px !important',
        marginTop: '40px',
      },
      '& .customContentHeader': {
        marginTop: '0px !important',
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,
      '& .section-alternate': {
        padding: '48px 64px',
        paddingBottom: '0px',
      },
      '& .section-header__overline-wrapper': {
        color: palette.primary.main,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 500,
        },
      },
      '& .testimonial-name': {
        color: palette.text.primary,
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },

        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 190,
          },
        },
        '& .react-multi-carousel-dot--active button': {
          backgroundColor: palette.text.highlight,
        },
        '& .testimonial-message': {
          color: palette.text.primary,
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      backgroundColor: palette.background.secondaryLight,
      '& .hero-static-bg': {
        backgroundColor: 'unset',
        color: `${palette.primary.contrastText} !important`,
      },
      '& .hero-static-section': {
        '& .hero-static-title, .hero-static-subtitle,': {
          color: `${palette.primary.contrastText} !important`,
        },
        '& .primary-static-button': {
          background: palette.secondary.main,
          color: palette.primary.contrastText,
          borderRadius: 4,
        },
        '& .section-header__title': {
          color: palette.text.primary,
          fontSize: 36,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .customBackToHomeButton, .view-more-button': {
        backgroundColor: palette.background.secondaryLight,
        borderColor: palette.background.secondaryLight,
        color: palette.primary.contrastText,
        '&:hover': {
          background: palette.verticalBar.used,
        },
      },
      '& .section-header': {
        marginBottom: '40px',
      },
      '& .hero-title': {
        fontSize: '65px',
      },
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.text.highlight,
        fontWeight: 600,
      },
      '& .savings-topheader': {
        color: `${palette.text.highlight} !important`,
        fontWeight: '500',
      },
      '& .savings-contact-card': {
        padding: 0,
      },
      '& .footer-bar': {
        backgroundColor: palette.background.primaryLight,
        color: palette.text.description,
        '&. footer-bar-text': {
          color: `${palette.text.description} !important`,
        },
      },
      '@media (max-width: 900px)': {
        '& .section-header__title': {
          fontSize: '34px',
        },
        '& .section-header__subtitle': {
          fontSize: '18px',
        },
      },

      '& .howItWorksRoot': {
        '& .section-header': {
          marginBottom: '0 !important',
        },
        '& .section-header__title-wrapper': {
          maxWidth: '560px',
        },
        '& .section-header__title': {
          fontSize: '44px',
          color: palette.primary.main,
          marginBottom: '10px',
          fontWeight: 500,
        },
        '& .section-header__subtitle': {
          fontSize: '19px',
          marginBottom: '10px',
          color: `${palette.text.secondary} !important`,
        },
        '& .cover-image-wrapper': {
          backgroundColor: 'red !important',
          padding: '15px',
        },
        '& .step-title': {
          fontWeight: 600,
          marginBottom: '20px',
          color: palette.text.primary,
        },
        '& .step-content': {
          marginBottom: '20px',
        },
      },
      '& .footer-bar-text': {
        color: `${palette.text.description} !important`,
        fontSize: '19px',
        fontWeight: 400,
        padding: 24,
        textAlign: 'center',
      },
    },

    /*Contact Us styling */
    '& .contactUsRoot': {
      '& .home-hero-wrapper': {
        marginTop: '10px',
        backgroundImage: `url(${contactUsBg})`,
        backgroundColor: palette.background.light,
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '62% auto',

        '& .contactHeaderTitle': {
          fontSize: '50px',
          fontWeight: 600,
          marginBottom: '20px',
        },
        '& .contactHeaderSubtitle': {
          fontWeight: 300,
          fontSize: '28px',
          marginBottom: '30px',
        },
        '& .customSubtitleItems': {
          fontSize: '18px',
        },
        '@media (max-width: 747px)': {
          backgroundSize: '110% auto',
          '& .customTitleInnerContainer': {
            marginTop: '220px',
          },
          '& .section-alternate__content': {
            paddingTop: 0,
          },
        },
        '& .section-header': {
          marginTop: 225,
        },
        '& .image-wrapper': {
          '& .image': {
            '@media (min-width: 900px)': {
              display: 'none',
            },
          },
        },

        '@media (max-width: 900px)': {
          '& .hero-section': {
            maxHeight: '100%',
          },
          '& .hero-left-section': {
            display: 'flex',
            zIndex: 1,
          },
          '& .section-header': {
            padding: '5px',
            marginTop: '-100px',
          },
          '& .section-header__title': {
            fontSize: '40px',
            fontWeight: 600,
          },
          '& .section-header__subtitle': {
            fontSize: '20px !important',
            fontWeight: '300 !important',
          },
          backgroundImage: 'none',
          marginTop: '50px',
          '& .image-wrapper': {
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
            marginTop: '15px',
          },
        },
        '& .section-header__title-wrapper': {
          maxWidth: '500px',
        },
        '& .section-header__subtitle': {
          fontSize: '28px',
          fontWeight: 400,
          maxWidth: 550,
        },
        '& .customIcon': {
          marginRight: '12px',
        },
      },

      '& .faq-contact-header-section': {
        minHeight: '547px',
      },
    },

    /* How it works */
    '& .howitworks-section': {
      '& .section': {
        padding: '48px 64px',
        paddingBottom: '0px',
      },
      background: palette.text.highlight,
      '& .howitworks-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: `1px solid ${palette.divider}`,
        padding: '0 0px 40px',
        '& .howitworks-title': {
          marginBottom: '20px',
          '& .section-header__title-wrapper': {
            maxWidth: '560px',
          },
        },
        '& .working-steps-container': {
          width: '90%',
          paddingBottom: '24px',
          marginBottom: '24px',
          borderBottom: `1px solid ${palette.divider}`,
          '&:last-child': {
            borderBottom: 'none',
            marginBottom: 0,
          },
          '@media(max-width: 900px)': {
            marginLeft: '0px',
            width: '100%',
          },
        },
        '& .howitworks-wrapper-left': {
          marginLeft: 'auto',
        },
        '& .cover-image-wrapper': {
          maxWidth: '656px',
        },
        '& .how-cover-image': {
          width: '100%',
          height: '100%',
          maxWidth: '656px',
          borderRadius: '5%',
        },
      },
      '@media(max-width:900px)': {
        '& .section': {
          padding: '48px 24px',
          paddingBottom: '0px',
        },
        '& .howitworks-title': {
          marginBottom: '24px !important',
        },
        '& .working-steps-container': {
          paddingBottom: '16px',
          marginBottom: '16px',
        },
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        backgroundColor: palette.background.header,
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .find-provider-section, & .plan-selection-section, & .checkout-hero-section':
        {
          background: palette.background.header,
          '& .hero-home-button': {
            background: palette.primary.contrastText,
            color: palette.text.description,
            '&:hover': {
              color: palette.primary.contrastText,
              background: palette.verticalBar.used,
            },
          },
        },
      '& .checkout-hero-section':{
        marginTop: '60px !important',
      },
      '& .planCard': {
        '&:hover': {
          backgroundColor: palette.background.primaryLight,
          color: palette.text.primary,
        },
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.background.secondaryLight,
        color: palette.primary.contrastText,
        '&:not(.Mui-disabled):hover': {
          backgroundColor: palette.primary.contrastText,
          color: palette.background.secondaryLight,
        },
        '&.Mui-disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          color: 'rgba(0, 0, 0, 0.26)',
          boxShadow: 'none',
        },
      },
      '& .customEditButton': {
        backgroundColor: palette.text.highlight,
      },
    },

    /* Find a Provider Style */
    '& .provider-home-button': {
      backgroundColor: palette.background.secondaryLight,
      border: palette.background.secondaryLight,
      '&:hover': {
        background: palette.verticalBar.used,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.light,
          color: `${palette.primary.contrastText} !important`,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
          color: palette.text.primary,
          '&:hover': {
            color: palette.text.primary,
          },
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .section-header__title': {
        color: `${palette.text.primary} !important`,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.background.dark,
      },
      '& .MuiSwitch-track': {
        borderColor: palette.background.secondaryLight,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked': {
        color: palette.text.highlight,
        borderColor: palette.background.primary,
        '& .MuiSwitch-thumb': {
          borderColor: palette.primary.main,
          backgroundColor: palette.background.dark,
        },
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        borderColor: palette.background.secondaryLight,
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '& .customEditButton': {
        background: 'none',
        color: palette.text.primary,
      },
      '& .customEditIcon': {
        stroke: palette.text.primary,
      },
      '& .provider-details': {
        border: `1px solid ${palette.primary.main}`,
      },
    },

    /* FAQ */
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        fontWeight: 400,
        color: palette.text.secondary,
      },
      '& .faq-get-started': {
        backgroundColor: palette.background.secondaryLight,
        color: palette.text.primary,
        '&:hover': {
          background: palette.verticalBar.used,
        },
      },
      '& .faq-link': {
        fontWeight: 'normal',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px',
          color: palette.text.primary,
        },
      },
      '& .collapseIcon, .expandIcon': {
        color: palette.verticalBar.used,
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.background.light,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
      },
      'media (min-width: 900px)': {
        '& .contact-card-title': {
          fontSize: 48,
        },
        '& .contact-card-subtitle': {
          fontSize: 20,
        },
      },
      '& .provider-contact-details': {
        fontSize: 16,
      },
      '& .provider-contact-link': {
        fontSize: 20,
      },
    },

    /* Static Footer */
    '& .footerMainContainer': {
      '& .customMainContent': {
        lineHeight: '56px',
        maxWidth: 500,
      },
      '& .MuiButton-root': {
        backgroundColor: palette.background.secondaryLight,
        '&:hover': {
          background: palette.verticalBar.used,
        },
      },
      '@media(max-width: 900px)': {
        '& .customMainContent': {
          lineHeight: '40px',
          maxWidth: 500,
        },
      },
    },

    /* Employee */
    '& .employerRootContainer': {
      background: palette.background.description,
      '& .home-hero-wrapper': {
        backgroundImage: `${employerBg}`,
        backgroundColor: 'unset',
        position: 'relative',

        '@media(max-width: 900px)': {
          paddingTop: 0,
        },

        '& .hero-background': {
          objectFit: 'cover',
          position: 'absolute !important',
          left: '250px !important',
          '@media(max-width: 1024px)': {
            left: '350px !important',
          },
        },
        '& .hero-section': {
          display: 'flex',
          alignItems: 'center',
          maxHeight: '620px',
        },
        '& .home-hero-title': {
          maxWidth: '100%',
        },
        '& .home-hero-subtitle': {
          color: palette.text.primary,
          fontSize: 18,
        },
        '& .hero-link-button': {
          background: palette.verticalBar.used,
          color: palette.text.highlight,
        },
        '& .login-button': {
          borderColor: palette.verticalBar.used,
          background: palette.text.highlight,
          color: palette.verticalBar.used,
          '&:hover': {
            background: palette.text.highlight,
          },
        },
        '@media screen and (max-width: 768px)': {
          '& .home-hero-title': {
            fontSize: '34px',
            color: palette.text.primary,
          },
        },
        '& .header-subtitle-divider': {
          marginTop: '0px !important',
          marginBottom: '32px !important',
        },
        '& .image': {
          display: 'block',
        },
        '@media(min-width: 1024px) and (max-width: 1366px)': {
          '& .image': {
            objectPosition: 'center',
            display: 'block',
          },
          '& .header-subtitle-divider': {
            marginTop: 12,
            marginBottom: 25,
          },
          '& .hero-title': {
            fontSize: 36,
          },
        },
        '& .customSubtitleItems': {
          fontSize: '18px !important',
        },
      },
      '& .hero-link-button, .login-button': {
        borderRadius: 4,
      },
      '& .hero-subtitle-divider-container': {
        '& .hero-subtitle-divider': {
          border: `2px solid ${palette.text.primary}`,
        },
      },
      '& .accordion__item-wrapper': {
        paddingTop: '10px',
        border: 'none !important',
        borderBottom: `1px solid ${palette.divider} !important`,
        borderRadius: '0 !important',
      },

      /* Subscription */
      '& .customSubscriptionWrapper': {
        background: palette.background.description,
        '& .section-header__subtitle, .customDisclaimerText': {
          color: palette.text.light,
        },
        '& .section': {
          '@media(min-width: 900px)': {
            padding: '64px',
          },
        },
        '& .subscription-getstarted-button': {
          background: palette.verticalBar.used,
          color: palette.text.highlight,
        },
        '& .customHeader': {
          maxWidth: '100%',
        },
        '& .customStaticCard': {
          height: 300,
          border: `1px solid ${palette.primary.main}`,
          borderRadius: '12px;',
        },
        '@media(min-width: 768px) and (max-width: 1180px)': {
          '& .customCardContainer': {
            maxWidth: '48%',
          },
        },
        '& .customValue': {
          color: palette.secondary.main,
        },
        '& .step-counter': {
          background: `${palette.background.dark} !important`,
          color: palette.text.highlight,
        },
        '& .customStartMembership': {
          borderRadius: 4,
          height: 70,
        },
        '& .MuiSwitch-thumb': {
          background: palette.text.highlight,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.verticalBar.used,
        },
        '& .MuiSwitch-track': {
          border: 'none',
          background: palette.verticalBar.used,
        },
        '& .customCardContent': {
          paddingBottom: 0,
        },
      },

      /* How it works */
      '& .howitworks-section': {
        '& .howitworks-wrapper': {
          borderBottom: 'none',
        },
        '& .step-counter': {
          background: `${palette.background.dark} !important`,
          color: palette.text.highlight,
        },
      },

      /* Metrics */
      '& .customMetricsRoot': {
        background: palette.secondary.main,
        '& #metrics-section': {
          '@media(min-width: 900px)': {
            padding: '48px 64px',
          },
          '& .left-section': {
            justifyContent: 'center',
            '& .title-box': {
              marginBottom: 36,
            },
          },
          '& .right-section': {
            justifyContent: 'center',
            '@media(max-width: 899.9px)': {
              padding: 0,
            },
            '& .title-box': {
              marginBottom: 36,
            },
          },
        },
        '& .section-header__title, .customMetricsDescription': {
          color: palette.text.highlight,
        },
        '& .metrics': {
          '& .section-header__title': {
            maxWidth: 600,
          },
          '& .metrics-getstarted-button': {
            background: palette.verticalBar.used,
            color: palette.text.highlight,
            borderRadius: 4,
            height: 56,
          },
        },
        '& .customDivider': {
          display: 'none',
        },
      },

      /* Comparison */
      '& .customComparisonContainer': {
        background: palette.verticalBar.used,

        '& .customImage': {
          marginBottom: 0,
        },
      },
      '& .customImage': {
        border: 'none',
      },
      '& .customSubtitle': {
        maxWidth: 400,
      },

      /* FAQ */
      '& .FAQSection': {
        background: palette.background.description,
        padding: '48px 24px',

        '@media(min-width: 900px)': {
          padding: '48px 64px',
        },
        '& .accordion__item-wrapper': {
          background: palette.background.description,
          '& .expandIcon, .collapseIcon': {
            color: palette.verticalBar.used,
          },
        },
        '& .accordion__collapsable-text': {
          color: palette.text.light,
        },
      },

      /* Hero Static Footer */
      '& .hero-static-bg': {
        backgroundColor: `${palette.secondary.main} !important`,
        color: `${palette.primary.contrastText} !important`,
      },
      '& .hero-static-section': {
        '& .hero-static-title, .hero-static-subtitle,': {
          color: `${palette.primary.contrastText} !important`,
        },
        '& .primary-static-button': {
          background: `${palette.verticalBar.used} !important`,
          color: `${palette.text.highlight} !important`,
          borderRadius: 4,
        },
      },
      '& .customBar': {
        color: palette.text.highlight,
      },
      '& .bar_accordion__item-wrapper': {
        padding: 0,
      },
    },

    /* Dashboard */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
    '& .benefits-done-wrappper': {
      background: palette.primary.light,
    },
    '& .benefits-done-icon': {
      fill: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .stepperIconRoot': {
        borderColor: palette.text.primary,
        '& .stepperIconText': {
          fill: palette.text.primary,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.text.primary,
      },
      '& .stepLabelActive': {
        color: palette.text.secondary,
      },
      '& .stepperIconActive': {
        color: `${palette.text.primary} !important`,
        '& .stepperIconText': {
          fill: `${palette.text.highlight} !important`,
        },
      },
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.text.primary,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .icon-wrapper': {
        '& .groupIcon': {
          fill: palette.text.primary,
        },
      },
      '& .customAddMembersLink': {
        color: palette.text.secondary,
      },
      '& .cancelPolicyLink, & .termsLink': {
        color: palette.text.secondary,
      },
    },

    /*Subscription Success */
    '& .success-wrapper': {
      maxWidth: '470px',
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.background.secondaryLight,
        color: palette.primary.contrastText,
        '&:hover': {
          background: palette.verticalBar.used,
        },
      },
      '& .cancel-button': {
        background: palette.primary.contrastText,
        color: palette.text.description,
        border: `1px solid ${palette.background.secondaryLight}`,
        '&:hover': {
          background: palette.background.secondaryLight,
          color: palette.primary.contrastText,
        },
      },
    },

    /*loader style */
    '& .plans-loader': {
      color: palette.secondary.main,
    },

    /* Coupon Styles */
    '@media(max-width: 900px)': {
      '& .coupon-container': {
        height: 90,
        paddingTop: 16,
      },
      '& .coupon-text': {
        flexDirection: 'column',
      },
      '& .coupon-icon': {
        display: 'none',
      },
    },
  },
};
